import React from "react";
import { Card, Table, TableBody, TableRow, TableCell, Box } from "@material-ui/core";

const CardSeller = ({ sellerForm }) => {
  return (
    <Card>
      <Table>
        <TableBody>
          <TableRow>
            <TableCell>氏名（法人名）</TableCell>
            <TableCell>{sellerForm.name}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>郵便番号</TableCell>
            <TableCell>
              {sellerForm.postalFirst} - {sellerForm.postalSecond}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>住所</TableCell>
            <TableCell>{sellerForm.address}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>電話番号</TableCell>
            <TableCell>{sellerForm.phone}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>適格請求書の登録番号</TableCell>
            <TableCell>{sellerForm.invoiceRegistrationNumber}</TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </Card>
  );
};

CardSeller.defaultProps = {
  sellerForm: {
    name: "",
    postalFirst: "",
    postalSecond: "",
    address: "",
    phone: "",
  },
};

export default CardSeller;